import React from 'react';
import pathfinder from '@fiverr-private/pathfinder';
import { LinkCard } from '@fiverr-private/layout_components';
import { Link, Text } from '@fiverr-private/typography';
import { CPRA_COPIES } from '../../../lib/copies';

export const PrivacyLinkCard = () => (
  <LinkCard display="flex" gap="8" direction="column" padding="8">
    <div>
      <svg width="81" height="74" viewBox="0 0 81 74" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6.00879 9.5C1.65739 10.3449 0.810079 13.4633 1.03228 17.8898C1.92107 35.0999 27.0296 46.9652 27.0111 63.3305C27.0111 67.757 23.9003 72.0182 19.5489 72.8631C15.1975 73.708 11.5312 70.5305 11.2534 66.3795C11.0868 64.3591 11.6978 61.6774 11.6978 61.6774L26.0088 59"
          stroke="#404145"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
        <path
          d="M60.7166 40C63.8142 43.9096 68.4513 50.4503 67.9748 55.4346C67.5532 59.8815 64.8956 64.1988 60.5883 65.0511L22.0088 72"
          stroke="#404145"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
        <path
          d="M44.0088 12.5C44.8206 17.7519 47.617 22.1938 51.0088 27"
          stroke="#404145"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
        <path
          d="M38.06 26.328L17.9399 29.672"
          stroke="#404145"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M37.0561 38.2458L27.9609 39.7549"
          stroke="#404145"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
        <path
          d="M46.9601 1.1266L6.00879 9.5C9.07921 8.89366 11.9277 10.4301 13.3519 12.8176C14.5172 14.7503 14.5727 17.2135 14.2027 18.6915C14.1658 18.862 14.2952 19.0326 14.4802 18.9947L54.3217 11.0554C55.413 8.45952 55.2095 5.40887 53.6743 3.6467C52.1021 1.78978 49.6236 0.596054 46.9601 1.1266Z"
          stroke="#404145"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
        <path
          d="M47.992 44.8967C45.8612 41.3809 46.5005 35.095 47.2462 32.8576L49.3771 32.3249C49.3771 32.3249 48.8444 29.1288 51.2948 26.0391C54.1714 22.3102 62.4815 14.8523 78.5691 14C72.7094 20.499 68.5543 31.579 67.4889 33.2837C65.3581 34.7752 63.2273 35.7342 63.2273 35.7342L65.145 37.6519C65.145 37.6519 54.491 46.6014 47.992 44.8967Z"
          fill="#1DBF73"
          stroke="#1DBF73"
          strokeWidth="1.5"
          strokeMiterlimit="10"
        />
        <path
          d="M65.9973 23.1621C53.8516 32.4311 47.4592 44.1507 45.0088 51.8217"
          stroke="#404145"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
        />
      </svg>
    </div>
    <Text>
      {CPRA_COPIES.PRIVACY_CARD_TEXT}{' '}
      <Link href={pathfinder('legal_portal_article_page', { category: 'privacy', page_slug: 'privacy-policy' })}>
        {CPRA_COPIES.PRIVACY_CARD_LINK}
      </Link>
    </Text>
  </LinkCard>
);
